import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import Checkbox from '@mui/material/Checkbox'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons/faEllipsisV";
import PersistentDataGrid from '../../../components/table/PersistentDataGrid';
import { GridToolbar } from '@mui/x-data-grid';
import { usePaginationState } from '../../../hooks/usePaginationState';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { addStateToDb, clearAddState } from '../../../redux/slices/Master/State/addStateSlice'
import { setShowMessage } from '../../../redux/slices/notificationSlice'
import { Modal, Button } from 'react-bootstrap';
import AlertDeleteModal from '../../AlertDelete/AlertDeleteModal';
import { Switch } from '@mui/material';
import axios from 'axios'
import { Tooltip } from "@mui/material";
import translations from '../../../assets/locals/translations';
const Part_List = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const currentLanguage = useSelector((state) => state.language.language);
    const t = translations[currentLanguage] || translations['en'];
    const [modalShow, setModalShow] = React.useState(false);
    const [checked, setChecked] = useState(true);
    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState(null);
    const [type, setType] = useState(null);
    const [id, setId] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [modalState, setModalState] = useState(false);
    const [partsList, setPartsList] = useState([]);
    const [editID, setEditID] = useState(0);
    const [evData, setEvData] = useState({
        partName: "",
        partNumber: "",
        partDescription: "",
        is_active: false,
        hsn: 34567
    });

    const [partColumnShowHideModel, setPartColumnShowHideModel] = useState({});
    const [paginationModel, handlePaginationModelChange] = usePaginationState('partListPaginationState', { pageSize: 50, page: 0 });

    const handlePartColumnShowHideChange = (part_newShowHideModel) => {
        setPartColumnShowHideModel(part_newShowHideModel);
        localStorage.setItem('part_columnShowHide', JSON.stringify(part_newShowHideModel));
    };

    useEffect(() => {
        const part_savedShowHideModel = JSON.parse(localStorage.getItem('part_columnShowHide'));
        if (part_savedShowHideModel) {
            setPartColumnShowHideModel(part_savedShowHideModel);
        }
    }, []);
    const handleShow = () => {
        setEditMode(false);
        setEvData({
            partName: '',
            partNumber: '',
            partDescription: '',
            is_active: '',
            hsn: ''
        });
        setModalShow(true);
        setModalState(false)
    }
    const handleClose = () => {
        setModalShow(false);
    }
    const redirectModal = () => {
        navigate(-1);
    };

    const editeStateModal = (data) => {
        setEditID(data.id);
        setEditMode(true);
        setEvData({
            partName: data.name,
            partNumber: data.part_no,
            partDescription: data.description,
            is_active: data.is_active,
            hsn: data.hsn_no
        });
        // data.is_active === '1' ? setChecked(true) : setChecked(false);
        setModalShow(true);
        setModalState(true);
    }
    const handleIsActiveChange = (event) => {
        setChecked(event.target.checked);
    };
    const hideConfirmationModal = () => {
        setDisplayConfirmationModal(false);
    };

    const deleteStateAlert = (data) => {
        console.log(editMode, 'eddd');
        setType('state_delete');
        setId(data.id)
        setDeleteMessage(`${translations[currentLanguage].areyousuredelete || 'Are You Sure You Want To Delete The'} Part '${data.name}'?`);
        setDisplayConfirmationModal(true);
    }
    const submitDelete = (type, id) => {

    }
    const getAllParts = async () => {
        const url = `${process.env.REACT_APP_NODE_URL}/api/master/get-parts`;
        const config = {
            headers: {
                token: localStorage.getItem('rbacToken')
            }
        };
        await axios.get(url, config).then((response) => {
            if (response.data && response.data.isSuccess) {
                console.log(response.data.result)
                setPartsList(response.data.result);
            }
        });
    }
    useEffect(() => {
        getAllParts();
    }, [])
    useEffect(() => {
        console.log('evData ***********8', evData)
    }, [evData])

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(evData, 'evdata');
        console.log(checked, 'check');
        console.log(editID, 'editIdSubmit');

        const url = `${process.env.REACT_APP_NODE_URL}/api/master/add-parts`;
        const editurl = `${process.env.REACT_APP_NODE_URL}/api/master/edit-parts/${editID}`;
        const config = {
            headers: {
                token: localStorage.getItem('rbacToken')
            }
        };

        const requestData = {
            name: evData.partName,
            part_no: evData.partNumber,
            description: evData.partDescription,
            hsn_no: evData.hsn,
            is_active: checked === true ? '1' : '0'
        };


        if (editID === 0) {
            console.log(editID, 'submittime')
            await axios.post(url, requestData, config)
                .then((response) => {
                    if (response.data && response.data.isSuccess) {
                        console.log('response', response.data.result);
                        setModalShow(false);
                        getAllParts();
                        setEditID(0);
                    }
                });
        } else {
            await axios.post(editurl, requestData, config)
                .then((response) => {
                    if (response.data && response.data.isSuccess) {
                        console.log('response', response.data.result);
                        setModalShow(false);
                        getAllParts();
                        setEditID(0);
                    }
                });
        }


        // dispatch(setShowMessage('All field must be field'))
        setEvData({
            partName: '',
            partNumber: '',
            partDescription: '',
            is_active: '',
            hsn: ''
        });
    };

    const onChangeHandler = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setEvData({ ...evData, [name]: value })
    }
    const switchStyles = {
        switchColor: '#3E5367',
        handleColor: '#FFF',
    };
    const [selectAll, setSelectAll] = useState(false);
    const [rowData, setRowData] = useState([]);

    const handleHeaderCheckboxClick = () => {
        setSelectAll(!selectAll);
    }

    const handleChildCheckboxClick = (itemId) => {
        const updatedRowsData = rowData.map((row) => {
            if (row.id == itemId) {
                return {
                    ...row,
                    checkbox: !row.checkbox,
                };
            }
            return row;
        });
        setRowData(updatedRowsData);
    }


    const label = { inputProps: { "aria-label": "Checkbox demo" } };


    const columns = [
        {
            field: "id",
            headerName: (
                <Checkbox
                    {...label}
                    checked={selectAll}
                    onClick={handleHeaderCheckboxClick}
                />
            ),
            minWidth: 90,
            renderCell: (params) => (
                <Checkbox
                    {...label}
                    checked={params.row.checkbox}
                    onClick={() => handleChildCheckboxClick(params.row.id)}
                />
            ),
        },
        {
            field: 'partName',
            headerAlign: 'left',
            align: 'left',
            headerName: t.partname || 'Part Name',
            minWidth: 120,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.name ? params.row.name : '-'}`
            }
        },
        {
            field: 'partNumber',
            headerAlign: 'left',
            align: 'left',
            headerName: t.partnumber || 'Part Number',
            minWidth: 130,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.part_no ? params.row.part_no : '-'}`
            }
        },
        {
            field: 'partDescription',
            headerAlign: 'left',
            align: 'left',
            headerName: t.partdescription || 'Part Description',
            minWidth: 200,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.description ? params.row.description : '-'}`
            }
        },
        {
            field: 'hsn',
            headerAlign: 'left',
            align: 'left',
            headerName: t.hsn || 'HSN',
            minWidth: 80,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.hsn_no ? params.row.hsn_no : '-'}`
            }
        },
        {
            field: 'is_active',
            headerName: t.active || 'Active',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            minWidth: 90,
            flex: 1,
            renderCell: (params) => (
                params.row.is_active === '1' ? <CheckIcon style={{ color: 'green' }} /> : <ClearIcon style={{ color: 'red' }} />
            ),

        },
        {
            field: "menu",
            headerName: (
                <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
            ),
            className: "bg-dark",
            sortable: false,
            filterable: false,
            headerAlign: "right",
            align: "right",
            disableColumnMenu: true,
            width: 130,
            // flex: 1,
            position: "sticky",
            renderCell: (params) => (
                <div className="d-flex justify-content-center dotHoverempicon ">
                    <FontAwesomeIcon icon={faEllipsisV} />
                    <div className="expandDiv">
                        <Tooltip title="Edit">
                            <button className='myActionBtn m-1'
                                onClick={() => { editeStateModal(params.row) }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                                </svg>
                            </button>
                        </Tooltip>
                    </div>
                </div>
            ),
        },
    ];

    useEffect(() => {
        const rowsData = partsList.map((item, index) => ({
            ...item,
            id: index + 1,
            checkbox: selectAll,
        }));
        setRowData(rowsData);
    }, [partsList, selectAll]);

    return (
        <>
            <div className=''>
                {/* <NavLink to={/edit-user}>callme</NavLink > */}
                <div className='my-3  d-flex align-items-end justify-content-end'>
                    <div className='d-flex align-items-center' type='button'>

                        <h6 className='m-0 ps-1'>
                            <button type="button" className="btn btn-primary"
                                onClick={handleShow}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-plus-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                </svg>&nbsp;
                                {t.addpart || 'Add Part'}
                            </button>
                        </h6>
                        <Button
                            variant="btn btn-warning mx-1"
                            style={{ width: '75px', height: '40px', fontSize: '14px', borderRadius: '20px' }}
                            onClick={() => {
                                redirectModal();
                            }}
                        >
                            {t.back || 'Back'}
                        </Button>
                    </div>
                </div>


                <div className='tableMenuHover' style={{ height: '85vh', width: '100%' }}>
                    <PersistentDataGrid
                        rows={rowData}
                        columns={columns}
                        columnVisibilityModel={partColumnShowHideModel}
                        onColumnVisibilityModelChange={handlePartColumnShowHideChange}
                        getRowId={(params) => {
                            return params.id
                        }}
                        className='rounded'
                        style={{ fontFamily: 'Poppins', padding: 5, backgroundColor: 'white', }}
                        pageSizeOptions={[10, 15, 25, 50]}
                        rowsPerPageOptions={[10, 20, 25, 50, 100]}
                        paginationModel={paginationModel}
                        onPaginationModelChange={handlePaginationModelChange}
                        components={{
                            Toolbar: GridToolbar,
                            NoRowsOverlay: () => (
                                <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <span>There is no Users with current branch</span>
                                </div>)
                        }}
                        componentsProps={{
                            toolbar: {
                                position: 'right',
                                style: { fontFamily: 'Poppins', alignSelf: 'end' },
                            },
                        }}
                        rowSelection={false}
                        autoPageSize={false}
                    />
                </div>
            </div>


            <AlertDeleteModal
                showModal={displayConfirmationModal}
                confirmModal={submitDelete}
                hideModal={hideConfirmationModal}
                type={type} id={id} message={deleteMessage}
            />
            {/* state modal */}
            <Modal
                show={modalShow}
                onHide={handleClose}
            >
                <Modal.Header closeButton>
                    <h5 className="modal-title" id="districtModalLabel">{t.addpart || 'ADD PART'}</h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <div className="mb-3">
                            <label htmlFor="recipient-name" className="col-form-label">{t.partname || 'Part Name'}:</label>
                            <input type="text" className="form-control" id="recipient-name" name="partName"
                                defaultValue={evData.partName} onChange={(e) => { onChangeHandler(e) }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="message-text" className="col-form-label">{t.partnumber || 'Part Number'}:</label>
                            <input className="form-control" id="message-text" name="partNumber"
                                defaultValue={evData.partNumber} onChange={(e) => { onChangeHandler(e) }}
                            ></input>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="message-text" className="col-form-label">{t.partdescription || 'Part Description'}:</label>
                            <textarea className="form-control" id="message-text" name="partDescription"
                                defaultValue={evData.partDescription} onChange={(e) => { onChangeHandler(e) }}
                            ></textarea>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="message-text" className="col-form-label">{t.hsn || 'HSN'}:</label>
                            <input className="form-control" id="message-text" name="hsn"
                                defaultValue={evData.hsn} onChange={(e) => { onChangeHandler(e) }}
                            ></input>
                        </div>
                        {/* <div className="mb-3">
                            <label htmlFor="message-text" className="col-form-label" name="is_active">Active:</label>
                            <Switch defaultChecked={evData.is_active == '1' ? true : false} onChange={handleIsActiveChange} style={{
                                // background: switchStyles.switchColor,
                                '--react-switch-bg-color': switchStyles.switchColor,
                                '--react-switch-handle-color': switchStyles.handleColor,
                            }} />
                        </div> */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary"
                        onClick={handleClose}
                    > {t.close || 'Close'} </Button>
                    <Button variant="primary"
                        onClick={handleSubmit}
                    >  {t.save || 'Save'}  </Button>
                </Modal.Footer>
            </Modal>
            {/* state modal end*/}
        </>
    )
}

export default Part_List
